import { LangFile } from './'
const Texts:LangFile = {
    noData: "Ingen data",
    homepagetitle: "Home Page",
    desktopPlatform: "Desktop Platform",
    operationsPlatform: "Operations Platform",
    required: "Nødvendigt",
    optional: "Valgfrit",
    overview: "Oversigt",
    default: "Standard",
    select: "Vælg",    
    action: "Handling",
    changes: "Ændringer",
    unknown: "Ukendt",
    search: "Søg",
    filterBy: "Filtrer",
    yes: "Ja",
    no: "Nej",
    from: "Fra",
    to: "Til",
    settings: "Indstillinger",
    
    languages: {
        en: "English",
        dk: "Dansk",
        es: "Español",
        de: "Deutsch",
        ma: "Mandarin"
    },

    user: {
        user: "Bruger",
        userName: "Brugernavn",
        userInformations: "Bruger information",
        userId: "Bruger-ID",
        firstName: "Fornavn",    
        lastName: "Efternavn",
        phone: "Telefon",
        email: "Email",
        password: "Kodeord",
        repeatPassword: "Gentag kodeord",
        country: "Land",
        address: "Addresse"
    },

    farm: {
      farmName: "Gårdnavn",
      city: "By",
      street: "Vej",
      vat: "CVR",
    },
    
    buttons: {
        goBackBtn: "Gå tilbage",
        createBtn: "Opret",
        cancelBtn: "Fortryd",
        saveBtn: "Gem",
        logOutBtn: "Log ud",
        loginbtn: "Log ind",
        quickEntry: "Masserediger",
        next: "Næste",
        prev: "Forrige",
        goToSiteList: "Gå til side listen",
        details: "Detaljer",
        edit: "Rediger",
        add: "Tilføj",
        remove: "Fjern",
        view: "Vis",
        reset: "Nulstil",
        move: "Flyt",
        skip: "Spring over",
        plan: "Planlæg",
        forNow: "Indtil videre",
        startFeeding: "Start Fodring",
        standard: "Standard",
        discard: "Kassér",
        selectAll: "Vælg alle",
        deselectAll: "Fravælg alle"
    },
 
    cookie:{
        header:"Cookies",
        context:`Agrisys A/s use cookies for the following purposes:\n`+
        `1* To support the website's functionality, for example by remembering your settings regarding cookies, preferred languages, currencies, etc.\n`+
        `2* To perform statistical analysis of your use of the website, for example by measuring what type of content you are looking at and clicking on.\n`+
        `\n`+
        `By pressing “Accept all” you accept our use of cookies.\n`+
        `Else a minimun of cookies will be used required by the service to function, for example to manage login, and data fetching from the consys platfrom.`,
        accept:"Accept necessary",
        acceptAll:"Accept All"
    },

    loginFlow: {
        login: {
            header: "Velkommen tilbage!",
            footerText: "Endnu ikke registreret?",
            create: "Opret ny bruger",
            error: "Kan ikke logge ind",
            forgotPassword: "Glemt kodeord?",
            resetPassword: "Nulstil kodeord"
        },
        forgotPassword: {
            text:"Hvis der ikke er en email tilknyttet brugernavnet, venligst kontakt supporten for yderligere hjælp!",
            text2:"Venligst ikke luk dette vindue før hele nulstillingsprocessen er fuldendt.",
            noEmail: "Ingen tilknyttet email?",
            contactSupport: "Kontakt support",
            error: "Brugernavn nødvendigt"
        },
        resetPassword: {
            text:`En midlertidig kode er blevet sendt til din email. Venligst\n`+
            `skriv det herunder, for at oprette en ny adgangskode.`,
            temporaryCode: "Midlertidig kode",
            newPassword: "Nyt kodeord",
            repeatPassword: "Gentag nyt kodeord",
            createNewPassword: "Opret nyt kodeord",
            text2: "Modtog ikke en kode?",
            error: "Kan ikke oprette nyt kodeord"
        },
        createUser: {
            header: "Ny bruger",
            error: "Kan ikke oprette bruger"
        },
        chooseSite: {
            header: "Vælg side",
            column1: "Gårdnavn",
            column2: "Manager",
            column3: "Kolonne 3",
            column4: "Kolonne 4"
        }
    },

    globalMenu: {
        home: "Hjem",
        dashboard: "Dashboard",
        kpi: "KPI",
        feedCurves: "Foderkurver",
        ComponentAlternatives: "Komponent Alternativer",
        mixtures: "Mixturer",
        silos: "Siloer",
        siloSettings: "Silo Indstillinger",
        animals: "Dyr",
        animalGroups: "Dyregrupper",
        reports: "Rapporter",
        logBook: "Logbog",
        globalSettings: "Indstillinger"
    },
    global_subMenu: {
        animals:{
            animalsEdit: "Animals Edit"
        }
    },

    toolsMenu: {
        tools: "Tools",
        graphQl: "Graph Ql",
        xml: "XML",
        farms: "Gårde",
        users: "Brugere"
    },
    tools_subMenu: {
        graphQl: {
            configurations: "Konfigurationer",
            software: "Software"
        }
    },
    locationFeeder: {
        sections: {
            section: "Sektion",
            sectionNo: "Sektionsnummer",
            sections: "Sektioner",
            to: "Til"
        },
        newSectionPopup: {
          newSection: "Ny sektion",
          layout: "Layout",
          io: "I/O Boards",
          apply: "Tilføj",
          columns: "Kolonner (maks 2)",
          rows: "Rækker",
          firstPenNo: "Første bås nr.",
          Order: "Rækkefølge",
          asc: "Stigende",
          desc: "Faldende",
          direction: "Retning",
          horizontal: "Horisontalt",
          vertical: "Vertikalt",
          numberOfPens: "Antal båse",
          tableViewDisclaimer: "Klik på en bås for at fjerne den eller tilføje den igen.",
          penContent: "Bås indhold",
          feederOnly: "Kun feeder", 
          water: "Vand",
          activator: "Aktivator",
          pen: "Bås", 
          chooseIO: "Vælg I/O Board",
          feederOutput: "Feeder Output",
          waterOutput: "Vand Output",
          activatorInput: "Aktivator Input",
          lanController: "LAN Controller",
          remainingOutputs: "Outputs tilbage",
          remainingInputs: "Inputs tilbage"
        },
        sectionsPopup: {
            feedCorrections: "Nuværende foderændringer",
        },
        penPopup: {
            pen: "Bås",
            activations: "Aktiveringer",
            lastActivation: "Seneste aktivering",
            activator: "Aktivator",
            feeder: "Feeder",
            motor: "Motor",
            lastDays: "Seneste 10 dage",
            inThisPen: "I denne bås",
            emptyPen: "Tom bås",
            empty: "Tom",
            penValueHeaders: "Hold musen på en værdi for at se dets type",
            goToAnimalPage: "Gå til dyrets side",
            feedKg: "Foder (Kg)",
            fedTotal: "Fodret total",
            feedConsumption: "Foderforbrug",
            addAnimalToPen: "Tilføj dyr til bås"
        },
        planSkip: {
            planSkip: "Planlæg foderstop",
            plannedSkip: "Planlagt foderstop",
            timeSpan: "Tidsinterval",
            timeAmount: "Tidsmængde",
            startDate: "Start dato",
            endDate: "Slut dato",
            startTime: "Starttidspunkt",
            endTime: "Sluttidspunkt"
        },
        overView: {
            systemControls: "System Kontrol",
            start: "Start",
            stop: "Stop",
            calibrate: "Kalibrér",
            systemOn: "Tændt",
            systemOff: "Slukket",
            emptySystem: "Tøm",
            systemStateRunning: "Kører",
            systemStateEmptying: "Tømmer",
            systemStateCalibrating: "Kalibrerer",
            systemStatePaused: "Kører ikke"
        }
    },
    progressComponents: {
        inThisSystem: "I dette system",
        animalsNo: "Antal dyr",
        currentProgress: "Nuværende udvikling"
    },
    feed: {
        feedPlan: {
            feedPlan: "Foderplan",
            feedCurve: "Foderkurve",
            components: "Komponenter",
            milestones: "Milepæle",
            name: "Navn",
            readyComponent: "Klar",
            priority: "Prioritet",
            ds: "TS",
            energy: "Energi",
            protein: "Protein",
            day: "Dag",
            milestone: "Milepæl"
        },
        feedCorrections: {
            feedCorrection: "Foderkorrigering",
            increased: "Øget",
            decreased: "Reduceret",
            disabled: "Deaktiveret",
            active: "Aktiv",
            skipFeeding: "Skip fodring",
            feeding: "Fodring",
            noSkip: "Intet planlagtt foderskip"
        },
        remaining: {
            today: "Spist idag",
            yesterday: "Spist igår"
        },
        fed: {
            today: "Fodret idag",
            period: "Fodret seneste periode"
        },
        feedCurve: {
          addFeedcurve: "Tilføj foderkurve",
          createFeedCurve: "Opret foderkurve",
          createFeedCurveFromScratch: "Opret ny foderkurve fra start",
          copyFeedcurve: "Kopier foderkurve",
          deleteFeedcurve: "Slet foderkurve",
          feedcurveName: "Foderkurvenavn",
          fromFeedcurve: "Fra foderkurve",
          newFeedcurve: "Ny foderkurve",
          spreading: "Spredning",
          corrections: "Korrigeringer",
          watchFeedcurve: "Se foderkurve",
          emptyFeedcurve: "Klik på rediger-knappen for at starte konfigurering af foderkurven.",
          noFeedcurve: "Ingen foderkurve fundet"
        },
        settings: {
          feedSpeed: "Foderhastighed (g/min)",
          maxAmount: "Maks periode mængde (kg)",
          remaining: "Overskudsfoder",
          stimoli: "Foderstimuli",
          addStimoli: "Tilføj stimoli",
          singleStimoli: "Enkel stimoli",
          repeatStimoli: "Gentag stimoli",
          minutesApart: "minutter imellem",
          noStimoli: "Ingen stimoli",
          pass: "Overfør til næste periode",
          toPass: "KG maks til overførsel",
          doNotPass: "Overfør ikke til næste periode",
          noComponents: "Ingen foderkomponenter fundet"
        }
    },
    units: {
        total: "Total",
        kg: "Kg",
        mA: "mA",
        pct: "pct",
        g: "g",
        min: "min",
        farrowed: "Faret",
        minutAgo: "Minut siden",
        minutesAgo: "Minutter siden",
        hour: "Time",
        hours: "Timer",
        hourAgo: "Time siden",
        hoursAgo: "Timer siden",
        timesToday: "Gange idag",
        timeToday: "Gang idag",
        capacity: "Kapacitet",
        days: "Dage",
        imperial: "Imperial",
        metric: "Metrisk",
        percentage: "Procent"
    },
    attentions: {
        attentions: "Bemærkninger",
        attention: "Bemærkning",
        attentionType: "Bemærkningstyper",
        problem: "Problem",
        problems: "Problemer",
        warning: "Advarsel",
        warnings: "Advarsler",
        systemAlert: "System Alarm",
        systemGood: "System Kører",
        systemNeutral: "System Slukket",
        systemWarning: "System Advarsel",
        goToSystem: "Gå til system"
    },
    reports: {
      report: "Rapport",
      farrowing: "Farring",
      farrowingsToday: "Farringer Idag",
      farrowed: "Farede dyr",
      template: "Skabelon",
      addTemplate: "Tilføj Skabelon",
      copyTemplate: "Kopier Skabelon",
      newTemplate: "Ny Skabelon",
      createNewReport: "Opret ny rapport fra start",
      noReportFound: "Ingen rapport fundet",
      noDataParameterFound: "Intet dataparameter fundet",
      noFilterParameterFound: "Intet filterparameter fundet",
      dataLevel: "Data Level",
      filterParameter: "Filter Parameter",
      dataParameter: "Data Parameter",
      archiveReport: "Arkiver Rapport",
      unArchiveReport: "Fjern Rapport fra arkiv",
      saveAsTemplate: "Gem som skabelon",
      archive: "Arkiv",
      archivedReport: "Arkiveret rapport",
      noStartDateFound: "Ingen startdato fundet",
      noEndDateFound: "Ingen slutdato fundet",
      reportName: "Rapport navn",
      newReport: "Ny rapport",
      fromTemplate: "Fra skabelon",
      showInReport: "Vis i rapporten",
      filterByNumber: "Rapport nummer",
      filterByName: "Rapport navn alfabetisk"
    },
    settingsPages: {
      globalSettings: {
        userSettings: "Bruger indstillinger",
        farmSettings: "Gård indstillinger",
        userManagement: "Bruger håndtering",
        timeZone: "Tidszone",
        units: "Måleenhed",
        feedDayStart: "Foderdag start",
        newMilestone: "Ny milepæl"
      },
      locationFeederSettings:{
        dailyRotation: "Daglig rotation",
        dailyRotationDisclaimer: "NB: Hvis systemet er slukket, vil en daglig rotation sørge for at vedligeholde motoren.",
        feedInSilos: "Foder i siloer",
        attentionLimit: "Nederste bemærkningsgrænse",
        inputOutputConnections: "Input/Output forbindelser",
        feedSpeed: "Foder hastighed",
        minimumFeedSpeed: "Minimum foderhastighed (g/min)",
        maximumFeedSpeed: "Maximum foderhastighed (g/min)",
        on: "Til",
        off: "Fra"
      }
    },
  animalPages:{
    animalGroups: {
      group: "Gruppe",
      animalId: "Antal dyr",
      createGroup: "Opret gruppe",
      newGroup: "Ny gruppe",
      groupName: "Gruppe navn",
    },
    animal: {
      animal: "Dyr",
      animalId: "Dyre nr.",
      latestMilestone: "Nuv. milepæl",
      milestoneDay: "Nuv. milepælsdag",
      responderNo: "Responder nr.",
      location: "Lokation",
      lifeNo: "Livsnr.",
      condition: "Tilstand",
      group: "Gruppe",
      animalType: "Dyretype",
      totalCycleDay: "Totale cyklus dag",
      newAnimal: "Nyt dyr",
      noAnimal: "Ingen dyr valgt",
      feedBalance: "Foder Balance",
      birthDate: "Fødselsdato",
      basicInfo: "Basis info",
      noAnimalSelected: "Intet dyr valgt",
      remainingToday: "Levnsliste idag",
      remainingYesterday: "Levnsliste igår",
      feed: "Foder",
      marking: "Mærkning",
      events: "Begivenheder",
      eventName: "Begivenhedsnavn",
      eventDate: "Begivenhedsdato",
      eventNotes: "Begivenhedsnoter",
      noTimeline: "Ingen tidslinje tilgængelig"
    }
  }
}
export default Texts